import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';
import {isMobile} from '#core/utils/context-utils.js';

import {generateSearchInput} from '#core/application/modules/tiles/search/search-input.js';
import {
    generateRecentSearch,
    generateSearchResultGroup,
    generateSearchResultItem,
} from '#core/application/modules/tiles/search/search-result.js';
import {generateToggleButtonRow} from '#core/application/modules/tiles/button/toggle-button/index.js';

export function searchFactory(PALETTE) {
    if (!isMobile()) {
        return {};
    }

    return {
        SearchView: {
            style: {
                searchBox: {
                    zIndex: 2,
                    _mobile_flexBasis: '100%', // fix search overlay layout
                },
                container: {
                    margin: '0 0 10px 0',
                },
                resultsContainer: {
                    _mobile_maxHeight: '80vh',
                    padding: '8px 0',
                },
            },
            searchInput: generateSearchInput(PALETTE.SEARCH_INPUT),
            messageText: {
                style: {
                    wordBreak: 'break-word',
                    ...PALETTE.SEARCH_RESULT.SEARCH_RECENT_ITEM_TEXT,
                },
            },
            messageContainer: {
                style: {
                    padding: '8px',
                },
            },
            sportMenu: generateToggleButtonRow(PALETTE.SEARCH_SPORT_MENU_SWITCHER, true),
        },
        RecentSearch: generateRecentSearch(PALETTE.SEARCH_RESULT),
        SearchResultGroup: generateSearchResultGroup(PALETTE.SEARCH_RESULT),
        SearchResultItem: generateSearchResultItem(PALETTE.SEARCH_RESULT),
        SearchOverlay: {
            overlay: {
                style: {
                    overlay: {
                        ...resolveBackground(PALETTE.SEARCH_OVERLAY_BG),
                    },
                },
            },
            searchBackButtonIcon: icon(PALETTE.SEARCH_OVERLAY_BACK_BUTTON_ICON_COLOR),
            searchView: {
                searchDiscoveryView: {
                    launcherIcon: icon(PALETTE.SEARCH_DISCOVERY_SEARCH_LAUNCHER_ICON_COLOR),
                },
            },
        },
        SearchControllerView: {
            searchDiscoveryView: {
                launcherIcon: icon(PALETTE.SEARCH_DISCOVERY_SEARCH_LAUNCHER_ICON_COLOR),
            },
        },
    };
}
